// utilities for keyboard event handling

const KEY_NAMES = {
    ENTER: 'Enter',
    SPACE: ' ',
    ESCAPE: 'Escape',
    TAB: 'Tab',
};

function getHandler(keys: string[], handlerFn: (e: any) => void);
function getHandler(condition: (e: any) => boolean, handlerFn: (e: any) => void);
function getHandler(
    keysOrCondition: string[] | ((e: any) => boolean),
    handlerFunc: (e: any) => void
) {
    return function (e: { key?: string }): void {
        if (typeof keysOrCondition === 'function') {
            if (!keysOrCondition(e)) return;
        } else {
            if (!keysOrCondition.includes(e.key)) return;
        }
        handlerFunc(e);
    };
}

// this function should not be exported
// if only single key has to be handled
//   export a function for that key
//   like functions below for enter and space
function _getHandlerForKey(key: string, handlerFunc: (e: any) => void) {
    return getHandler([key], handlerFunc);
}

export function enterKeyHandler(handlerFunc: (e: any) => void) {
    return _getHandlerForKey(KEY_NAMES.ENTER, handlerFunc);
}

export function spaceKeyHandler(handlerFunc: (e: any) => void) {
    return _getHandlerForKey(KEY_NAMES.SPACE, handlerFunc);
}

export function escapeKeyHandler(handlerFunc: (e: any) => void) {
    return _getHandlerForKey(KEY_NAMES.ESCAPE, handlerFunc);
}

export function tabKeyHandler(handlerFunc: (e: any) => void) {
    return getHandler(e => e.key === KEY_NAMES.TAB && !e.shiftKey, handlerFunc);
}

export function shiftTabKeyHandler(handlerFunc: (e: any) => void) {
    return getHandler(e => e.key === KEY_NAMES.TAB && e.shiftKey, handlerFunc);
}
